(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-anniversary-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  class YGAnniversaryCountdownBanner extends HTMLElement {
    connectedCallback() {
      this.countdownEnd = this.parseCountdownEnd(this.dataset.countdownEnd);
      this.storageKey = this.dataset.storageKey;
      this.closeButton = this.querySelector('[data-countdown-close]');
      this.handleClose = this.handleClose.bind(this);

      if (!window.Shopify?.designMode && this.hasBeenDismissed()) {
        this.hideBanner();
        return;
      }

      this.closeButton?.addEventListener('click', this.handleClose);
      this.updateCountdown();

      if (Number.isFinite(this.countdownEnd)) {
        this.countdownInterval = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    parseCountdownEnd(value) {
      const normalizedValue = value
        .trim()
        .replace(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2})$/, '$1T$2');

      return new Date(normalizedValue).getTime();
    }

    disconnectedCallback() {
      this.closeButton?.removeEventListener('click', this.handleClose);
      window.clearInterval(this.countdownInterval);
    }

    hasBeenDismissed() {
      try {
        return window.sessionStorage.getItem(this.storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    handleClose() {
      try {
        window.sessionStorage.setItem(this.storageKey, 'true');
      } catch (error) {
        // The banner can still be dismissed when storage is unavailable.
      }

      this.hideBanner();
      window.clearInterval(this.countdownInterval);
    }

    hideBanner() {
      this.hidden = true;
      const sectionRoot = this.closest('.shopify-section');
      if (sectionRoot) sectionRoot.hidden = true;
    }

    updateCountdown() {
      const remainingTime = Number.isFinite(this.countdownEnd)
        ? Math.max(this.countdownEnd - Date.now(), 0)
        : 0;
      const units = {
        days: Math.floor(remainingTime / 86400000),
        hours: Math.floor((remainingTime % 86400000) / 3600000),
        minutes: Math.floor((remainingTime % 3600000) / 60000),
        seconds: Math.floor((remainingTime % 60000) / 1000),
      };

      Object.entries(units).forEach(([unit, value]) => {
        const unitElement = this.querySelector(`[data-countdown-unit="${unit}"]`);
        if (unitElement) unitElement.textContent = String(value).padStart(2, '0');
      });

      this.setAttribute(
        'aria-label',
        `${units.days} days, ${units.hours} hours, ${units.minutes} minutes, ${units.seconds} seconds remaining`
      );

      if (remainingTime === 0) window.clearInterval(this.countdownInterval);
    }
  }

  if (!window.customElements.get('yg-anniversary-countdown-banner')) {
    window.customElements.define('yg-anniversary-countdown-banner', YGAnniversaryCountdownBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-complete-offering"] && !Shopify.designMode) return;
  try {
    
  class YGCompleteOffering extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
    }
  }

  if (!window.customElements.get('yg-complete-offering')) {
    window.customElements.define('yg-complete-offering', YGCompleteOffering);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-content-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('yg-content-tabs')) {
    class YGContentTabs extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.isAnimating = false;
      this.handleResize = this.updateNavigation.bind(this);
    }

    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-content-tabs-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-content-tabs-panel]'));
      this.descriptions = Array.from(this.querySelectorAll('[data-content-tabs-description]'));
      this.scrollport = this.querySelector('[data-content-tabs-scroll]');
      this.viewport = this.querySelector('[data-content-tabs-viewport]');
      this.previousButton = this.querySelector('[data-content-tabs-prev]');
      this.nextButton = this.querySelector('[data-content-tabs-next]');

      this.bindEvents();
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this);
      window.requestAnimationFrame(this.handleResize);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.triggers?.forEach((trigger) => {
        trigger.removeEventListener('click', trigger.contentTabsClickHandler);
        trigger.removeEventListener('keydown', trigger.contentTabsKeydownHandler);
      });
      this.previousButton?.removeEventListener('click', this.previousClickHandler);
      this.nextButton?.removeEventListener('click', this.nextClickHandler);
      this.scrollport?.removeEventListener('scroll', this.handleResize);
      this.buyNowButtons?.forEach((button) => {
        button.removeEventListener('click', button.contentTabsBuyNowHandler);
      });
      this.querySelectorAll('[data-content-tabs-features]').forEach((features) => {
        features.removeEventListener('mouseenter', features.contentTabsEnterHandler);
        features.removeEventListener('mouseleave', features.contentTabsLeaveHandler);
      });
    }

    bindEvents() {
      this.triggers.forEach((trigger, index) => {
        trigger.contentTabsClickHandler = () => this.activateTab(index);
        trigger.contentTabsKeydownHandler = (event) => this.handleTabKeydown(event, index);
        trigger.addEventListener('click', trigger.contentTabsClickHandler);
        trigger.addEventListener('keydown', trigger.contentTabsKeydownHandler);
      });

      this.previousClickHandler = () => this.activateTab(this.activeIndex - 1);
      this.nextClickHandler = () => this.activateTab(this.activeIndex + 1);
      this.previousButton?.addEventListener('click', this.previousClickHandler);
      this.nextButton?.addEventListener('click', this.nextClickHandler);
      this.scrollport?.addEventListener('scroll', this.handleResize, { passive: true });

      this.buyNowButtons = Array.from(this.querySelectorAll('[data-content-tabs-buy-now]'));
      this.buyNowButtons.forEach((button) => {
        button.contentTabsBuyNowHandler = () => this.openDynamicCheckout(button);
        button.addEventListener('click', button.contentTabsBuyNowHandler);
      });

      this.querySelectorAll('[data-content-tabs-features]').forEach((features) => {
        features.contentTabsEnterHandler = () => this.revealFeatures(features);
        features.contentTabsLeaveHandler = () => this.resetFeatures(features);
        features.addEventListener('mouseenter', features.contentTabsEnterHandler);
        features.addEventListener('mouseleave', features.contentTabsLeaveHandler);
        this.updateFeatures(features);
      });
    }

    updateNavigation() {
      if (!this.scrollport || !this.viewport) return;
      const maxScroll = Math.max(0, this.scrollport.scrollWidth - this.scrollport.clientWidth);
      const isOverflowing = maxScroll > 2;
      const atStart = this.scrollport.scrollLeft <= 2;
      const atEnd = this.scrollport.scrollLeft >= maxScroll - 2;

      if (this.previousButton) this.previousButton.hidden = !isOverflowing || this.activeIndex <= 0 || atStart;
      if (this.nextButton) this.nextButton.hidden = !isOverflowing || this.activeIndex >= this.triggers.length - 1 || atEnd;
      this.viewport.classList.toggle('has-fade-left', isOverflowing && !atStart);
      this.viewport.classList.toggle('has-fade-right', isOverflowing && !atEnd);
      this.querySelectorAll('[data-content-tabs-features]').forEach((features) => this.updateFeatures(features));
    }

    revealTrigger(trigger) {
      if (!this.scrollport || !trigger) return;
      const targetLeft = trigger.offsetLeft - ((this.scrollport.clientWidth - trigger.offsetWidth) / 2);
      this.scrollport.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    }

    openDynamicCheckout(button) {
      const checkoutButton = button
        .closest('.yg-content-tabs__product-form')
        ?.querySelector('.shopify-payment-button__more-options');
      checkoutButton?.click();
    }

    revealFeatures(features) {
      if (features.scrollWidth <= features.clientWidth) return;
      features.classList.add('is-revealed');
      features.scrollTo({ left: features.scrollWidth - features.clientWidth, behavior: 'smooth' });
    }

    resetFeatures(features) {
      features.classList.remove('is-revealed');
      features.scrollTo({ left: 0, behavior: 'smooth' });
    }

    updateFeatures(features) {
      const hasOverflow = features.scrollWidth > features.clientWidth + 2;
      features.classList.toggle('has-overflow', hasOverflow);
      if (!hasOverflow) features.classList.remove('is-revealed');
    }

    async activateTab(index, shouldFocus = false) {
      if (index < 0 || index >= this.triggers.length || index === this.activeIndex || this.isAnimating) return;
      this.isAnimating = true;

      const previousPanel = this.panels[this.activeIndex];
      const nextPanel = this.panels[index];
      this.triggers.forEach((trigger, triggerIndex) => {
        const isActive = triggerIndex === index;
        trigger.setAttribute('aria-selected', String(isActive));
        trigger.tabIndex = isActive ? 0 : -1;
        if (isActive && shouldFocus) trigger.focus();
      });

      previousPanel?.classList.add('is-fading');
      await new Promise((resolve) => window.setTimeout(resolve, 180));
      if (previousPanel) {
        previousPanel.hidden = true;
        previousPanel.classList.remove('is-fading');
      }
      if (nextPanel) {
        nextPanel.hidden = false;
        nextPanel.classList.add('is-fading');
        void nextPanel.offsetWidth;
        nextPanel.classList.remove('is-fading');
      }

      this.descriptions.forEach((description, descriptionIndex) => {
        description.hidden = descriptionIndex !== index;
      });
      this.activeIndex = index;
      this.revealTrigger(this.triggers[index]);
      window.setTimeout(this.handleResize, 240);
      this.isAnimating = false;
    }

    handleTabKeydown(event, index) {
      let targetIndex = null;
      if (event.key === 'ArrowRight') targetIndex = Math.min(index + 1, this.triggers.length - 1);
      if (event.key === 'ArrowLeft') targetIndex = Math.max(index - 1, 0);
      if (event.key === 'Home') targetIndex = 0;
      if (event.key === 'End') targetIndex = this.triggers.length - 1;
      if (targetIndex === null) return;

      event.preventDefault();
      this.activateTab(targetIndex, true);
    }

    }

    window.customElements.define('yg-content-tabs', YGContentTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-get-to-know-slider"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('yg-get-to-know-slider')) {
    class YGGetToKnowSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.swiperElement = this.querySelector('[data-get-to-know-swiper]');
        this.previousButton = this.querySelector('[data-get-to-know-prev]');
        this.nextButton = this.querySelector('[data-get-to-know-next]');
        this.sectionElement = this.closest('[data-section-type="yg-get-to-know-slider"]');
        this.fadeElement = this.sectionElement?.querySelector('.yg-get-to-know-slider__fade');
        this.handleLayoutChange = this.updateLayout.bind(this);
        this.connectSwiper();

        this.resizeObserver = new ResizeObserver(this.handleLayoutChange);
        this.resizeObserver.observe(this.sectionElement || this);
      }

      disconnectedCallback() {
        window.clearTimeout(this.swiperInitTimer);
        this.resizeObserver?.disconnect();
        this.swiper?.off?.('slideChange', this.handleLayoutChange);
        this.swiper?.off?.('slideChangeTransitionEnd', this.handleLayoutChange);
        this.swiper?.off?.('resize', this.handleLayoutChange);
        this.swiper?.off?.('update', this.handleLayoutChange);
      }

      connectSwiper() {
        const swiper = this.swiperElement?.swiper;

        if (!swiper) {
          this.swiperInitTimer = window.setTimeout(() => this.connectSwiper(), 50);
          return;
        }

        this.swiper = swiper;
        this.configureResponsiveSlides();
        this.enableNativeNavigation();
        this.swiper.on('slideChange', this.handleLayoutChange);
        this.swiper.on('slideChangeTransitionEnd', this.handleLayoutChange);
        this.swiper.on('resize', this.handleLayoutChange);
        this.swiper.on('update', this.handleLayoutChange);
        this.updateLayout();
      }

      enableNativeNavigation() {
        if (!this.swiper?.navigation || !this.previousButton || !this.nextButton) return;

        const navigation = {
          prevEl: this.previousButton,
          nextEl: this.nextButton,
          disabledClass: 'swiper-button-disabled'
        };

        this.swiper.navigation.destroy();
        this.swiper.params.navigation = navigation;
        this.swiper.originalParams.navigation = navigation;
        this.swiper.navigation.init();
        this.swiper.navigation.update();
      }

      configureResponsiveSlides() {
        const breakpoints = this.swiper?.params?.breakpoints;

        if (!breakpoints) return;

        const mobileBreakpoint = {
          ...(breakpoints[260] || {}),
          slidesPerView: 1.05,
          spaceBetween: 16
        };
        const tabletBreakpoint = {
          ...(breakpoints[550] || {}),
          slidesPerView: 'auto',
          spaceBetween: 16
        };

        this.swiper.params.breakpoints = {
          ...breakpoints,
          260: mobileBreakpoint,
          400: tabletBreakpoint
        };
        this.swiper.originalParams.breakpoints = {
          ...this.swiper.originalParams.breakpoints,
          260: mobileBreakpoint,
          400: tabletBreakpoint
        };
        this.swiper.update();
      }

      updateLayout() {
        if (!this.sectionElement) return;

        const sectionRect = this.sectionElement.getBoundingClientRect();
        const componentRect = this.getBoundingClientRect();
        const inlineGutter = Math.max(0, componentRect.left - sectionRect.left);
        const contentRight = sectionRect.right - inlineGutter;
        const rightExtension = Math.max(0, window.innerWidth - sectionRect.right);
        const swiperEndPadding = Math.max(0, window.innerWidth - contentRight);
        const extensionChanged = this.rightExtension !== rightExtension || this.swiperEndPadding !== swiperEndPadding;

        if (extensionChanged) {
          this.rightExtension = rightExtension;
          this.swiperEndPadding = swiperEndPadding;
          this.sectionElement.style.setProperty('--get-to-know-viewport-right-extension', `${rightExtension}px`);
          this.sectionElement.style.setProperty('--get-to-know-swiper-end-padding', `${swiperEndPadding}px`);
          this.swiper?.update();
        }

        if (!this.fadeElement || !this.swiper) return;

        const hasRightOverflow = Array.from(this.swiper.slides).some((slide) => {
          return slide.getBoundingClientRect().right > window.innerWidth + 1;
        });

        this.fadeElement.hidden = !hasRightOverflow;
      }
    }

    window.customElements.define('yg-get-to-know-slider', YGGetToKnowSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-text-overlay"] && !Shopify.designMode) return;
  try {
    
  class YGVideoPopupTrigger extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleClick();
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick() {
      const popupId = this.dataset.popupId;
      const template = document.getElementById(`yg-popup-template-${popupId}`);
      if (!template) {
        console.error(`Popup template not found: yg-popup-template-${popupId}`);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate: template,
            popupClass: this.dataset.popupClass || 'yg-popup-video',
            closeBtnClass: this.dataset.closeBtnClass || 'yg-popup-video-close',
          },
        })
      );

      // The popup injects the video markup synchronously. Start playback right away
      // (within the click gesture) instead of waiting for the in-view lazy observer,
      // which doesn't reliably fire when the popup goes from display:none to visible.
      const video = document.querySelector('.yg-popup-box .yg-video-box');
      if (video && typeof video.playVideo === 'function') {
        video.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-video-popup-trigger')) {
    window.customElements.define('yg-video-popup-trigger', YGVideoPopupTrigger);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-number-slider"] && !Shopify.designMode) return;
  try {
    
  class YGNumberSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.hasAnimated = false;
      this.numbers = Array.from(this.querySelectorAll('.yg-number-slider__number'));

      if (!this.numbers.length) return;

      this.numbers.forEach((number) => {
        const counter = this.getCounter(number.textContent);

        if (!counter) return;

        number.dataset.ygCounterPrefix = counter.prefix;
        number.dataset.ygCounterValue = counter.value;
        number.dataset.ygCounterSuffix = counter.suffix;
        number.dataset.ygCounterDecimals = counter.decimals;
        number.dataset.ygCounterCommas = counter.hasCommas ? 'true' : 'false';
      });

      this.counterNumbers = this.numbers.filter((number) => number.dataset.ygCounterValue);

      if (!this.counterNumbers.length) return;

      if (!('IntersectionObserver' in window)) {
        this.play();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || this.hasAnimated) return;

            this.play();
            observer.unobserve(this);
          });
        },
        { threshold: 0.25 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    getCounter(content) {
      const text = content.trim();
      const match = text.match(/^([^0-9A-Za-z+\-.,]*)([+\-]?\d[\d,]*(?:\.\d+)?)([^0-9A-Za-z.,\-]*)$/);

      if (!match) return null;

      const value = Number(match[2].replace(/,/g, ''));

      if (!Number.isFinite(value)) return null;

      const decimalPart = match[2].split('.')[1] || '';

      return {
        prefix: match[1],
        value: String(value),
        suffix: match[3],
        decimals: String(decimalPart.length),
        hasCommas: match[2].includes(','),
      };
    }

    play() {
      if (this.hasAnimated) return;

      this.hasAnimated = true;
      this.counterNumbers.forEach((number) => this.animateNumber(number));
    }

    animateNumber(number) {
      const target = Number(number.dataset.ygCounterValue);
      const decimals = Number(number.dataset.ygCounterDecimals);
      const duration = 1200;
      const startTime = performance.now();

      const render = (time) => {
        const progress = Math.min((time - startTime) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = target * easedProgress;

        number.textContent = this.formatNumber(number, currentValue, decimals);

        if (progress < 1) {
          requestAnimationFrame(render);
          return;
        }

        number.textContent = this.formatNumber(number, target, decimals);
      };

      requestAnimationFrame(render);
    }

    formatNumber(number, value, decimals) {
      const fixedValue = value.toFixed(decimals);
      const formattedValue =
        number.dataset.ygCounterCommas === 'true' ? Number(fixedValue).toLocaleString('en-US', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }) : fixedValue;

      return `${number.dataset.ygCounterPrefix}${formattedValue}${number.dataset.ygCounterSuffix}`;
    }
  }

  if (!window.customElements.get('yg-number-slider')) {
    window.customElements.define('yg-number-slider', YGNumberSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;

    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl;

      this.#sectionEl = {
        accordionList: this.querySelectorAll('.yg-process-steps-item'),
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        controls: this.querySelectorAll('.yg-process-steps-media'),
      };

      return this.#sectionEl;
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          const myIds = Array.from(this.querySelectorAll('[data-id]')).map((el) => el.getAttribute('data-id'));
          if (myIds.includes(event.detail.id)) {
            this.currentStep(event.detail.id);
          }
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          const myIds = Array.from(this.querySelectorAll('[data-id]')).map((el) => el.getAttribute('data-id'));
          if (myIds.includes(event.detail.id)) {
            this.nextStep(event.detail.id);
          }
        }
      });
    }

    nextStep(id) {
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });

      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  class YGProcessStepsMobile extends HTMLElement {
    #sectionEl;
    currentStepIndex = 0;
    swiperInstance = null;

    constructor() {
      super();
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl;

      this.#sectionEl = {
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        controls: this.querySelectorAll('.yg-process-steps-media'),
      };

      return this.#sectionEl;
    }

    connectedCallback() {
      this.initSwiper();

      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          const myIds = Array.from(this.querySelectorAll('[data-id]')).map((el) => el.getAttribute('data-id'));
          if (myIds.includes(event.detail.id)) {
            this.nextStep(event.detail.id);
          }
        }
      });
    }

    loadSwiperCtor() {
      if (window.Swiper || window.MinimogLibs?.Swiper) {
        return Promise.resolve(window.Swiper || window.MinimogLibs.Swiper);
      }

      if (typeof window.loadAssets !== 'function') {
        return Promise.resolve(null);
      }

      return window.loadAssets(['swiper.css', 'swiper.js'])
        .then(() => window.Swiper || window.MinimogLibs?.Swiper || null)
        .catch(() => null);
    }

    initFirstStep() {
      const slides = this.querySelectorAll('.yg-process-steps-slide');
      if (slides.length === 0) return;

      const firstSlide = slides[0];
      const firstId = firstSlide.querySelector('.yg-process-steps-media')?.getAttribute('data-id');
      if (firstId) {
        this.currentStep(firstId);
      }
    }

    nextStep(id) {
      const slides = this.querySelectorAll('.yg-process-steps-slide');
      const swiper = this.swiperInstance;

      if (!swiper || slides.length === 0) return;

      let currentIndex = 0;
      slides.forEach((slide, index) => {
        const media = slide.querySelector('.yg-process-steps-media');
        if (media && media.getAttribute('data-id') === id) {
          currentIndex = index;
        }
      });

      const nextIndex = (currentIndex + 1) % slides.length;
      this.currentStepIndex = nextIndex;
      swiper.slideToLoop(nextIndex);
    }

    currentStep(id) {
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    setActiveControl(id) {
      this.pauseAllVideos();
    }

    async startProgressForId(id) {
      await customElements.whenDefined('yg-progress-bar');
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    playVideo(id) {
      const videoEl = this.getVideoById(id);
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }

    getVideoById(id) {
      const slides = this.querySelectorAll('.yg-process-steps-slide');
      for (const slide of slides) {
        const media = slide.querySelector('.yg-process-steps-media');
        if (media && media.getAttribute('data-id') === id) {
          const videoEl = media.querySelector('yg-video');
          if (videoEl) {
            return videoEl;
          }
        }
      }
      return null;
    }

    pauseAllVideos() {
      const videoElements = this.querySelectorAll('yg-video');
      videoElements.forEach((video) => {
        try {
          if (video && typeof video.pauseVideo === 'function') {
            video.pauseVideo();
          }
        } catch (e) {
          // Ignore errors
        }
      });
    }

    async initSwiper() {
      if (this.swiperInstance) return;

      await window.waitForElementVisible?.(this);
      const SwiperCtor = await this.loadSwiperCtor();
      if (!SwiperCtor) return;

      const tabsEl = this.querySelector('.yg-process-steps-tabs');
      const swiperEl = this.querySelector('.yg-process-steps-swiper');
      const tabSlider = this.querySelector('.yg-process-steps-tabs .yg-process-steps-tab-slider');
      const tabs = Array.from(this.querySelectorAll('.yg-process-steps-tab'));
      if (!tabsEl || !swiperEl || tabs.length === 0) return;
      const hasContentTabsStyle = this.classList.contains('is-content-tabs-style');
      const contentTabsGap = parseFloat(getComputedStyle(tabsEl).getPropertyValue('--steps-content-tabs-gap')) || 0;

      const updateTabSlider = (activeTab) => {
        if (!activeTab || !tabsEl || !tabSlider) return;

        window.requestAnimationFrame(() => {
          tabSlider.style.setProperty('--active-left', activeTab.offsetLeft + 'px');
          tabSlider.style.setProperty('--active-width', activeTab.offsetWidth + 'px');
        });
      };

      const updateCurrentTabSlider = () => {
        const activeTab = tabs.find((tab) => tab.classList.contains('swiper-slide-thumb-active'));
        updateTabSlider(activeTab);
      };

      const updateActiveTab = (index) => {
        const activeTab = tabs.find((tab) => Number(tab.dataset.index) === index) || tabs[0];
        if (!activeTab || !tabsEl || !tabSlider) return;

        tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('swiper-slide-thumb-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        scrollTabIntoView(activeTab);
        updateTabSlider(activeTab);
        updateNavButtons(tabs.indexOf(activeTab));
      };

      const updateNavButtons = (activeIndex) => {
        const prevButton = this.querySelector('.yg-swiper-prev');
        const nextButton = this.querySelector('.yg-swiper-next');
        const hasOverflow = hasTabOverflow();
        const hasPreviousTab = hasOverflow && activeIndex > 0;
        const hasNextTab = hasOverflow && activeIndex < tabs.length - 1;
        prevButton?.classList.toggle('swiper-button-disabled', !hasPreviousTab);
        nextButton?.classList.toggle('swiper-button-disabled', !hasNextTab);
        tabsEl.classList.toggle('has-fade-left', hasContentTabsStyle && hasPreviousTab);
        tabsEl.classList.toggle('has-fade-right', hasContentTabsStyle && hasNextTab);
      };

      const scrollTabIntoView = (activeTab) => {
        if (!thumbnails || !activeTab) return;
        const slideIndex = tabs.indexOf(activeTab);
        if (slideIndex < 0) return;
        thumbnails.slideTo(slideIndex);
      };

      const hasTabOverflow = () => {
        const tabsWidth = tabs.reduce((width, tab) => width + tab.offsetWidth, 0);
        const gapsWidth = hasContentTabsStyle ? contentTabsGap * (tabs.length - 1) : 0;
        return tabsWidth + gapsWidth > tabsEl.clientWidth;
      };

      const thumbnails = new SwiperCtor(tabsEl, {
        slidesPerView: 'auto',
        centeredSlides: hasTabOverflow(),
        centeredSlidesBounds: true,
        watchOverflow: true,
        spaceBetween: hasContentTabsStyle ? contentTabsGap : 0,
        watchSlidesProgress: true,
      });

      const swiper = new SwiperCtor(swiperEl, {
        slidesPerView: 1,
        allowTouchMove: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        on: {
          init: (e) => {
            this.swiperInstance = e;
            updateActiveTab(e.realIndex || 0);
          }
        },
      });

      swiper.on('slideChange', () => {
        updateActiveTab(swiper.realIndex);

        const slides = this.querySelectorAll('.yg-process-steps-slide');
        const currentSlide = slides[swiper.realIndex];

        if (currentSlide) {
          const media = currentSlide.querySelector('.yg-process-steps-media');
          const currentId = media?.getAttribute('data-id');

          if (currentId) {
            this.currentStep(currentId);
          }
        }
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = Number(tab.dataset.index);
          if (Number.isNaN(index)) return;
          swiper.slideToLoop(index);
          updateActiveTab(index);
        });
      });

      window.addEventListener('resize', () => {
        thumbnails.params.centeredSlides = hasTabOverflow();
        thumbnails.update();
        updateActiveTab(swiper.realIndex || 0);
      });

      swiper.on('slideChangeTransitionEnd', () => {
        this.currentStepIndex = swiper.realIndex;
        updateCurrentTabSlider();
      });

      const prevButton = this.querySelector('.yg-swiper-prev');
      const nextButton = this.querySelector('.yg-swiper-next');

      prevButton?.addEventListener('click', () => {
        swiper.slidePrev();
      });

      nextButton?.addEventListener('click', () => {
        swiper.slideNext();
      });

      this.swiperInstance = swiper;
    }
  }

  if (!customElements.get('yg-process-steps-mobile')) {
    customElements.define('yg-process-steps-mobile', YGProcessStepsMobile);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-register-forms"] && !Shopify.designMode) return;
  try {
    
  class YGRegisterForms extends HTMLElement {
    connectedCallback() {
      this.retryCount = 0;
      this.boundDropdownRoots = new WeakSet();
      this.dropdownCleanupCallbacks = [];
      this.handleMutations = this.scheduleFormStyles.bind(this);
      this.observer = new MutationObserver(this.handleMutations);
      this.observer.observe(this, { childList: true, subtree: true });
      this.scheduleFormStyles();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }

      window.clearTimeout(this.retryTimer);

      this.dropdownCleanupCallbacks.forEach((cleanup) => cleanup());
      this.dropdownCleanupCallbacks = [];
    }

    scheduleFormStyles() {
      window.clearTimeout(this.retryTimer);
      this.retryTimer = window.setTimeout(() => {
        const hasStyledForm = this.applyFormStyles();

        if (!hasStyledForm && this.retryCount < 30) {
          this.retryCount += 1;
          this.scheduleFormStyles();
        }
      }, 100);
    }

    applyFormStyles() {
      const formEmbeds = this.querySelectorAll('shopify-forms-embed');
      let hasStyledForm = false;

      formEmbeds.forEach((formEmbed) => {
        const shadowRoot = formEmbed.shadowRoot;

        if (!shadowRoot) {
          return;
        }

        hasStyledForm = true;
        this.bindDropdownScrollbar(shadowRoot);

        let style = shadowRoot.querySelector('[data-yg-register-forms-style]');

        if (!style) {
          style = document.createElement('style');
          style.setAttribute('data-yg-register-forms-style', '');
          shadowRoot.append(style);
        }

        const form = shadowRoot.querySelector('form');
        const submitButton = shadowRoot.querySelector('[class*="_formSubmitButton_"]');
        const disclaimer = shadowRoot.querySelector('[class*="_formDisclaimer_"]');

        if (form && submitButton && disclaimer && disclaimer.parentElement !== form) {
          form.insertBefore(disclaimer, submitButton);
        }

        style.textContent = `
          :host {
            --inline-container-max-width: 450px;
            --forms-base-font-size: 14px;
            --forms-heading-font-size: var(--register-forms-heading-size);
            --forms-heading-font: normal 600 var(--register-forms-heading-size) / var(--register-forms-heading-line-height) PPMori-SemiBold, sans-serif;
            --form-text-color: var(--register-forms-input-text-color, #202020);
            --form-placeholder-color: var(--register-forms-label-color, #696d75);
            --form-background-color: var(--register-forms-input-background-color, #ffffff);
            --button-text-color: var(--register-forms-button-text-color, #ffffff);
            --button-background-color: var(--register-forms-button-background-color, #202020);
            --form-field-border: 0 0 0 1px var(--register-forms-input-border-color, rgba(32, 32, 32, 0.2));
            --form-field-border-focused: 0 0 0 2px var(--register-forms-input-border-color, rgba(32, 32, 32, 0.2));
            --form-field-border-radius: 5px;
            --button-border-radius: 5px;
          }

          [class*="_formHeader_"] {
            margin: 0 0 20px !important;
            text-align: center;
          }

          [class*="_textHeading_"] {
            font-family: PPMori-SemiBold, sans-serif !important;
            font-size: var(--register-forms-heading-size) !important;
            font-weight: 600 !important;
            line-height: 43.2px !important;
            letter-spacing: var(--register-forms-heading-tracking) !important;
          }

          [class*="_formFieldset_"] {
            box-sizing: border-box !important;
            width: 100% !important;
            gap: 12px;
            padding-inline: 2px;
          }

          [class*="_formFileInputField_"] {
            box-sizing: border-box !important;
            width: 100% !important;
            max-width: 100%;
          }

          [class*="_container_"] {
            grid-template-columns: minmax(0, 1fr) !important;
          }

          #form-container-ref {
            width: 100% !important;
            justify-self: stretch !important;
          }

          [class*="_formInputField_"],
          [class*="_formPhoneInputField_"],
          [class*="_selectToggle_"],
          [class*="_formSubmitButton_"] {
            box-sizing: border-box !important;
            min-height: var(--register-forms-input-height) !important;
            height: var(--register-forms-input-height) !important;
            border-radius: 5px !important;
          }

          [class*="_formInputField_"],
          [class*="_formPhoneInputField_"] {
            padding: 22.5px 15px 7.5px !important;
          }

          [class*="_formInputFieldLabel_"],
          [class*="_formAddressRegionPlaceholder_"] {
            color: var(--register-forms-field-label-color) !important;
          }

          [class*="_selectToggle_"],
          [class*="_formSubmitButton_"] {
            padding: 0 16px !important;
          }

          [class*="_selectToggle_"] [class*="_arrowDownIcon_"] {
            transform-origin: center;
            transition: transform 0.2s ease;
          }

          [class*="_selectToggle_"][aria-expanded="true"] [class*="_arrowDownIcon_"] {
            transform: rotate(180deg);
          }

          [role="listbox"] {
            max-height: min(320px, 45vh) !important;
          }

          [class*="_dropdownContainer_"] {
            max-height: min(320px, 45vh) !important;
          }

          [class*="_formInputField_"],
          [class*="_formPhoneInputField_"],
          [class*="_selectToggle_"] {
            box-shadow: 0 0 0 1px var(--register-forms-input-border-color, rgba(32, 32, 32, 0.2));
          }

          [class*="_checkboxInput_"] {
            accent-color: #000000 !important;
          }

          [class*="_verticalLayout_"] {
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: wrap;
            align-items: center;
            gap: var(--register-forms-radio-gap) !important;
          }

          [class*="_formFieldset_"] [class*="_formDisclaimer_"] {
            align-self: stretch;
            margin-top: 36px !important;
            color: var(--register-forms-input-text-color, #202020);
            font-size: 12px;
            line-height: 14px;
            text-align: center;
          }

          [class*="_formSubmitButton_"] {
            display: flex !important;
            align-self: center;
            align-items: center !important;
            justify-content: center !important;
            width: min(100%, var(--register-forms-submit-width)) !important;
            margin-inline: auto !important;
            border-radius: var(--register-forms-submit-radius) !important;
            line-height: 1 !important;
            text-align: center;
          }

          @media screen and (max-width: 699px) {
            [class*="_formHeader_"] {
              margin-bottom: 8px !important;
            }

            [class*="_textHeading_"] {
              font-size: var(--register-forms-mobile-heading-size) !important;
              line-height: 33.6px !important;
              letter-spacing: 0 !important;
            }

            [class*="_multiFieldLine_"] {
              display: flex !important;
              flex-direction: column !important;
              gap: 12px !important;
            }

            [class*="_fieldContainer_"] {
              width: 100% !important;
            }
          }
        `;
      });

      return hasStyledForm;
    }

    bindDropdownScrollbar(shadowRoot) {
      if (this.boundDropdownRoots.has(shadowRoot)) {
        return;
      }

      this.boundDropdownRoots.add(shadowRoot);

      let isScrollbarInteraction = false;

      const getListbox = (target) => {
        if (!(target instanceof Element)) {
          return null;
        }

        return target.closest('[role="listbox"]');
      };

      const handlePointerDown = (event) => {
        const listbox = getListbox(event.target);
        isScrollbarInteraction = Boolean(listbox && event.target === listbox && event.button === 0);
      };

      const handleFocusOut = (event) => {
        if (!isScrollbarInteraction || !getListbox(event.target)) {
          return;
        }

        event.stopImmediatePropagation();
      };

      const clearScrollbarInteraction = () => {
        window.requestAnimationFrame(() => {
          isScrollbarInteraction = false;
        });
      };

      shadowRoot.addEventListener('pointerdown', handlePointerDown, true);
      shadowRoot.addEventListener('focusout', handleFocusOut, true);
      window.addEventListener('pointerup', clearScrollbarInteraction, true);
      window.addEventListener('pointercancel', clearScrollbarInteraction, true);

      this.dropdownCleanupCallbacks.push(() => {
        shadowRoot.removeEventListener('pointerdown', handlePointerDown, true);
        shadowRoot.removeEventListener('focusout', handleFocusOut, true);
        window.removeEventListener('pointerup', clearScrollbarInteraction, true);
        window.removeEventListener('pointercancel', clearScrollbarInteraction, true);
      });
    }
  }

  if (!window.customElements.get('yg-register-forms')) {
    window.customElements.define('yg-register-forms', YGRegisterForms);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-button"]) return;
  try {
    
  class YGScrollButton extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.isInitialized = true;
      this.abortController = new AbortController();
      this.$button = this.querySelector('[data-scroll-button]');
      this.scrollFrame = null;
      const signal = this.abortController.signal;

      this.$button?.addEventListener('click', () => this.handleClick(), { signal });
      window.addEventListener('scroll', () => this.handleScroll(), { passive: true, signal });
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
      this.isInitialized = false;
    }

    handleScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateVisibility();
      });
    }

    updateVisibility() {
      this.setVisible(window.scrollY > window.innerHeight);
    }

    setVisible(isVisible) {
      this.toggleAttribute('scroll-hidden', !isVisible);
      this.setAttribute('aria-hidden', String(!isVisible));
      this.$button?.setAttribute('tabindex', isVisible ? '0' : '-1');
    }

    handleClick() {
      const hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setVisible(false);
      window.scrollTo({ top: 0, behavior: hasReducedMotion ? 'auto' : 'smooth' });
    }
  }

  if (!window.customElements.get('yg-scroll-button')) {
    window.customElements.define('yg-scroll-button', YGScrollButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-slideshow"] && !Shopify.designMode) return;
  try {
    
  class YGSlideshowProgress extends HTMLElement {
    connectedCallback() {
      this.isAutoplayEnabled = this.dataset.autoplay === 'true';
      this.$slideshow = this.querySelector('m-slideshow');
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
      this.handleAutoplayStart = this.handleAutoplayStart.bind(this);
      this.handleAutoplayStop = this.handleAutoplayStop.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.waitAttempts = 0;
      this.waitForSlider();
    }

    disconnectedCallback() {
      clearTimeout(this.waitTimer);
      clearTimeout(this.restartTimer);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);

      if (this.slider && !this.slider.destroyed) {
        this.slider.off('slideChangeTransitionEnd', this.handleTransitionEnd);
        this.slider.off('autoplayStart', this.handleAutoplayStart);
        this.slider.off('autoplayStop', this.handleAutoplayStop);
      }
    }

    waitForSlider() {
      const slider = this.$slideshow?.slider;

      if (slider && slider.initialized) {
        this.attachSlider(slider);
        return;
      }

      this.waitAttempts += 1;
      if (this.waitAttempts < 200 && this.isConnected) {
        this.waitTimer = setTimeout(() => this.waitForSlider(), 50);
      }
    }

    attachSlider(slider) {
      if (this.slider === slider) return;

      this.slider = slider;
      this.slider.params.speed = 0;
      this.slider.originalParams.speed = 0;
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (!this.isAutoplayEnabled) {
        this.clearProgress();
        return;
      }

      if (this.slider.params.autoplay) {
        this.slider.params.autoplay.disableOnInteraction = false;
      }
      if (this.slider.originalParams.autoplay) {
        this.slider.originalParams.autoplay.disableOnInteraction = false;
      }

      this.slider.on('slideChangeTransitionEnd', this.handleTransitionEnd);
      this.slider.on('autoplayStart', this.handleAutoplayStart);
      this.slider.on('autoplayStop', this.handleAutoplayStop);
      this.startAutoplay();
      this.restartProgress();
    }

    startAutoplay() {
      if (
        !this.isAutoplayEnabled ||
        document.hidden ||
        !this.slider?.autoplay ||
        this.slider.destroyed
      ) {
        return;
      }

      if (!this.slider.autoplay.running) {
        this.slider.autoplay.start();
      }
    }

    handleTransitionEnd() {
      this.startAutoplay();
      this.restartProgress();
    }

    handleAutoplayStart() {
      this.restartProgress();
    }

    handleAutoplayStop() {
      this.clearProgress();
      clearTimeout(this.restartTimer);
      this.restartTimer = setTimeout(() => {
        this.startAutoplay();
        this.restartProgress();
      }, 0);
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.clearProgress();
        return;
      }

      this.startAutoplay();
      this.restartProgress();
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;

      this.$slideshow.lastActive = null;
      this.startAutoplay();
    }

    restartProgress() {
      if (!this.isAutoplayEnabled || document.hidden) return;

      const $activeDot = this.querySelector('.swiper-pagination .sf__dot-active');
      this.clearProgress();

      if (!$activeDot) return;

      void $activeDot.offsetWidth;
      $activeDot.classList.add('yg-slideshow__dot-progress');
    }

    clearProgress() {
      this.querySelectorAll('.yg-slideshow__dot-progress').forEach(($dot) => {
        $dot.classList.remove('yg-slideshow__dot-progress');
      });
    }
  }

  if (!window.customElements.get('yg-slideshow-progress')) {
    window.customElements.define('yg-slideshow-progress', YGSlideshowProgress);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-solution-image-card"] && !Shopify.designMode) return;
  try {
    
  class YGVideoPopupTrigger extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleClick();
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick() {
      const popupId = this.dataset.popupId;
      const template = document.getElementById(`yg-popup-template-${popupId}`);
      if (!template) {
        console.error(`Popup template not found: yg-popup-template-${popupId}`);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate: template,
            popupClass: this.dataset.popupClass || 'yg-popup-video',
            closeBtnClass: this.dataset.closeBtnClass || 'yg-popup-video-close',
          },
        })
      );

      // The popup injects the video markup synchronously. Start playback right away
      // (within the click gesture) instead of waiting for the in-view lazy observer,
      // which doesn't reliably fire when the popup goes from display:none to visible.
      const video = document.querySelector('.yg-popup-box .yg-video-box');
      if (video && typeof video.playVideo === 'function') {
        video.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-video-popup-trigger')) {
    window.customElements.define('yg-video-popup-trigger', YGVideoPopupTrigger);
  }

  } catch(e) { console.error(e); }
})();
})();
